import React, { useEffect, useState } from "react";
import Loader from "../../components/loader";
import { Footer } from "../../layouts";
import DashboardNavbar from "../../components/dasboard/dashboardNavbar";
import DashboardCard from "../../components/dasboard/dashboardCard";
import { HeroSm } from "../../components";
import { Slang } from "../../helpers";
import $ from "jquery";
import { useSelector } from "react-redux";
import Dashboard from "../../layouts/dashboard";

const Home = () => {
  const [loadPage, setLoadPage] = useState(true);

  useEffect(() => {
    let tim1 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    const script = `
    new HSGoTo('.js-go-to');
    new HSHeader('#header').init();
    new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
`;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      clearInterval(tim1);

      $(".homescript").remove();
    };
  }, []);
  return <>{loadPage ? <Loader /> : <Main />}</>;
};

export default Home;

const Main = () => {
  const lang = Slang("dashboardNavbar");
  const dCard1Lang = Slang("dashboardNavbar.DashboardCard1");
  const dCard2Lang = Slang("dashboardNavbar.DashboardCard2");
  const dCard3Lang = Slang("dashboardNavbar.DashboardCard3");
  const dCard4Lang = Slang("dashboardNavbar.DashboardCard4");
  const dCard5Lang = Slang("dashboardNavbar.DashboardCard5");
  const svgDir = "./assets/vendor/duotone-icons";

  const user = useSelector((state) => state.auth.user);
  console.log(user);
  return (
    <>
      {/* <Dashboard  > */}
      <DashboardNavbar />
      <HeroSm title={lang("title")} />
      <main id="content" role="main" className="my-sm-5 my-md-0">
        <section>
          <div className="container content-space-6 content-space-t-lg-1 content-space-b-lg-3">
            <div className="row gy-4">
              <>
                <DashboardCard
                  className="col-md-6"
                  title={dCard1Lang("t1")}
                  description={dCard1Lang("t2")}
                  linkText={dCard1Lang("t3")}
                  icon={svgDir + "/com/com003.svg"}
                />
                <DashboardCard
                  className="col-md-6"
                  title={dCard2Lang("t1")}
                  description={dCard2Lang("t2")}
                  linkText={dCard2Lang("t3")}
                  icon={svgDir + "/fil/fil003.svg"}
                />
                <DashboardCard
                  className="col-md-6"
                  title={dCard4Lang("t1")}
                  description={dCard4Lang("t2")}
                  linkText={dCard4Lang("t3")}
                  icon={svgDir + "/fil/fil019.svg"}
                />
                <DashboardCard
                  className="col-md-6"
                  title={dCard3Lang("t1")}
                  description={dCard3Lang("t2")}
                  linkText={dCard3Lang("t3")}
                  icon={svgDir + "/elc/elc004.svg"}
                  cardLink="/profile"
                />
              </>

              {user.roles[0].name !== "client" && (
                <span
                  className={
                    user.roles[0].name === "client"
                      ? "w-100 d-flex justify-content-center"
                      : ""
                  }
                >
                  <DashboardCard
                    cardLink="/dashboard/company"
                    isAccount
                    icon={svgDir + "/fin/fin001.svg"}
                    className="col-md-6"
                    title={dCard5Lang("t1")}
                    description={dCard5Lang("t2")}
                    linkText={dCard5Lang("t2")}
                  />
                </span>
              )}
            </div>
          </div>
        </section>
      </main>
      {/* </Dashboard> */}
      <Footer />
    </>
  );
};
